import React, { useCallback, useState } from 'react';
import { Image as ImageUI } from 'react-bootstrap';
import { STATIC_IMAGE_URLS } from 'modules/core/constants';

interface IImage {
  src?: string;
  className?: string;
  testId?: string;
  onErrorPhoto?: string;
}

export const Image: React.FC<IImage> = ({ src, className, testId, onErrorPhoto }) => {
  const initialImageSrc = src || STATIC_IMAGE_URLS.icons.noPhoto;

  const [imageSrc, setImageSrc] = useState(initialImageSrc);

  const onError = useCallback(() => {
    setImageSrc(onErrorPhoto || STATIC_IMAGE_URLS.icons.noPhoto);
  }, [onErrorPhoto]);

  return <ImageUI src={imageSrc} onError={onError} className={className} data-testid={testId} />;
};
